<template>
    <div v-if="settings">
        <form id="update_services_settings_form">
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#inquiry_services_tab"
                           @click="gotoTab(1)">
                            {{ $t('application.services.inquiry_services') }}
                        </a>
                    </li>
<!--                    <li class="nav-item">-->
<!--                        <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#authentication_services_tab"-->
<!--                           @click="gotoTab(2)">-->
<!--                            {{ $t('application.services.authentication_services') }}-->
<!--                        </a>-->
<!--                    </li>-->
                    <li class="nav-item">
                        <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#financial_services_tab"
                           @click="gotoTab(3)">
                            {{ $t('application.services.financial_services') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
            <div class="tab-content">
                <div :class="['tab-pane', currentTab === 1 ? 'active' : '']" id="#inquiry_services_tab">
                    <div style="margin-top: 15px" id="inquiry_services" aria-labelledby="inquiry_services"
                         data-parent="#inquiry_services_acc">
                        <kt-row>
                            <div v-for="(service,index) in inquiry_services" :key="index" class="col-12">
                                <div>
                                    <kt-col xs="6" sm="6" lg="6" style="margin-top: 35px;display: inline-block">
                                        <kt-form-label for="refresh_token">
                                          {{ $t('application.services.' + service) }}
                                          {{ (service === 'iban_to_account') ? '(ست پی = استعلام شبا)' : '' }}
                                        </kt-form-label>
                                    </kt-col>
                                    <kt-col style="display: inline-block" xs="6" sm="4" lg="4">
                                        <kt-form-group>
                                            <kt-form-label :for="service">
                                                {{ $t('application.provider') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                :id="service"
                                                :name="service"
                                                v-model="settings[service]"
                                                class="form-control kt-selectpicker"
                                            >
                                                <option
                                                    v-for="provider in getProviders(service)" :value="provider"
                                                    v-bind:key="provider">
                                                    {{ providerTypeStr.get(provider) }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <hr>
                                </div>
                            </div>
                        </kt-row>
                    </div>
                </div>
<!--                <div :class="['tab-pane', currentTab === 2 ? 'active' : '']">-->
<!--                    <div style="margin-top: 15px" id="authentication_services" aria-labelledby="authentication_services"-->
<!--                         data-parent="#authentication_services_acc">-->
<!--                        <kt-row>-->
<!--                            <div v-for="(service,index) in authentication_services" :key="index" class="col-12">-->
<!--                                <div>-->

<!--                                    <kt-col xs="6" sm="6" lg="6" style="margin-top: 35px;display: inline-block">-->
<!--                                        <kt-form-label for="refresh_token">-->
<!--                                            {{ $t('application.services.' + service) }}-->
<!--                                        </kt-form-label>-->
<!--                                    </kt-col>-->
<!--                                    <kt-col style="display: inline-block" xs="6" sm="4" lg="4">-->
<!--                                        <kt-form-group>-->
<!--                                            <kt-form-label :for="service">-->
<!--                                                {{ $t('application.provider') }}-->
<!--                                            </kt-form-label>-->
<!--                                            <kt-form-select-->
<!--                                                :id="service"-->
<!--                                                :name="service"-->
<!--                                                v-model="settings[service]"-->
<!--                                                class="form-control kt-selectpicker"-->
<!--                                            >-->
<!--                                                <option-->
<!--                                                    v-for="provider in getProviders(service)" :value="provider"-->
<!--                                                    v-bind:key="provider">-->
<!--                                                    {{ providerTypeStr.get(provider) }}-->
<!--                                                </option>-->
<!--                                            </kt-form-select>-->
<!--                                        </kt-form-group>-->
<!--                                    </kt-col>-->
<!--                                    <hr>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </kt-row>-->
<!--                    </div>-->
<!--                </div>-->
                <div :class="['tab-pane', currentTab === 3 ? 'active' : '']">
                    <div style="margin-top: 15px" id="financial_services" aria-labelledby="financial_services"
                         data-parent="#financial_services_acc">
                        <kt-row>
                            <div v-for="(service,index) in financial_services" :key="index" class="col-12">
                                <div>
                                    <kt-col lg="2" md="2" sm="6" xs="12" style="margin-top: 10px">
                                        <p>
                                            {{ $t('application.services.' + service) }}
                                        </p>
                                    </kt-col>
                                    <kt-col lg="10" md="10" sm="6" xs="12">
                                        <div v-for="(bank, index) in getProviders(service)" v-bind:key="bank">
                                            <kt-row>
                                                <kt-col lg="6" md="6" sm="6" xs="12">
                                                    <kt-form-group ref="bank">
                                                        <kt-form-label for="bank">
                                                            {{ $t('label.bank') }}
                                                        </kt-form-label>
                                                        <kt-form-control
                                                            :value="bankIdStr.get(bank)"
                                                            disabled
                                                            :id="index"></kt-form-control>
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="4" md="4" sm="6" xs="12">
                                                    <kt-form-group ref="provider">
                                                        <kt-form-label for="provider">
                                                            {{ $t('application.provider') }}
                                                        </kt-form-label>
                                                        <kt-form-select id="provider" class="form-control"
                                                                        :name="service+'_'+bank"
                                                                        v-model="settings[service][bank]"
                                                        >
                                                            <option
                                                                v-bind:key="provider"
                                                                v-for="provider in getServiceBankProvider(service, bank)"
                                                                v-bind:value="provider"
                                                            >
                                                                {{ providerTypeStr.get(provider) }}
                                                            </option>
                                                        </kt-form-select>
                                                    </kt-form-group>
                                                </kt-col>
                                            </kt-row>
                                        </div>
                                    </kt-col>
                                </div>
                                <hr>
                            </div>
                        </kt-row>
                    </div>
                </div>
            </div>
        </form>

        <kt-col lg="12" style="margin-top: 60px">
            <kt-form-action class="mt-4">
                <kt-button
                    style="position: absolute;left: 0;bottom: 0"
                    class="m-2 btn-wide"
                    size="md"
                    variant="success"
                    type="button"
                    v-bind:wide="true"
                    id="update_services_settings_btn"
                    @click="updateServicesSettings()"
                >
                    {{ $t('btn.edit') }}
                </kt-button>
            </kt-form-action>
        </kt-col>
    </div>

</template>

<script>
import {
    providerType, providerTypeStr, providersHaveService,
    financialServices,
    authenticationServices,
    inquiryServices,
} from '@/constants/openBanking'
import $ from "jquery";
import toastr from "toastr";
import {i18n} from '@/plugins/i18n';
import {bankIdStr} from '@/constants/bankId'
import {KTApp} from "@/plugins/core/app";
import {openBankingService} from "@/common/api.service";

export default {
    components: {},
    props: {
        settings: {
            required: true,
        },
        service_bank_providers: {
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
        this.categorizeServices()
    },
    data() {
        return {
            providerType,
            providerTypeStr,
            providersHaveService,
            financialServices,
            authenticationServices,
            inquiryServices,
            financial_services: [],
            authentication_services: [],
            inquiry_services: [],
            currentTab: 1,
            bankIdStr
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_chose')
            })
        },
        updateServicesSettings() {
            let form = $('#update_services_settings_form')
            let btn = $('#update_services_settings_btn')

            let rules = {};
            let auth_inquiry_services = {...this.inquiryServices, ...this.authenticationServices}
            Object.values(auth_inquiry_services).forEach(value => {
                rules[value] = {required: true};
            })
            Object.values(this.financialServices).forEach(service => {
                Object.values(this.getProviders(service)).forEach(bank => {
                    rules[service + '_' + bank] = {required: true};
                })
            })

            form.validate({
                rules: rules,
                invalidHandler: function (form, validator) {
                    console.log('Validation errors:');
                    $.each(validator.errorList, function (index, error) {
                        console.log(error.message + ' for element: ' + error.element.name);
                    });

                    console.log('Validator object:', validator);
                },
            })

            if (!form.valid()) {
                return this.toastr.error(i18n.t('open_banking.message.fill_all'))
            }

            KTApp.progress(btn)
            openBankingService.adminUpdateServicesSettings(this.settings).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                    KTApp.unprogress(btn)
                }
            )
        },
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
        },
        getProviders(service) {
            return Object.keys(this.service_bank_providers[service])
        },
        getServiceBankProvider(service, bank) {
            return this.service_bank_providers[service][bank]
        },
        categorizeServices() {
            for (let service in this.settings) {
                if (Object.values(this.financialServices).includes(service))
                    this.financial_services.push(service)
                else if (Object.values(this.authenticationServices).includes(service))
                    this.inquiry_services.push(service)
                else if (Object.values(this.inquiryServices).includes(service))
                    this.inquiry_services.push(service)
            }
        }
    }
}
</script>
<style>
.modal .modal-content .modal-header .close:before {
    content: "" !important;
}

.modal .modal-content .modal-header .close {
    font-size: 1.8rem;
    line-height: .7;
}

</style>